/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationSalesCreate
 */
export interface OrganizationSalesCreate {
    /**
     * 
     * @type {string}
     * @memberof OrganizationSalesCreate
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSalesCreate
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSalesCreate
     */
    company_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSalesCreate
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSalesCreate
     */
    phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSalesCreate
     */
    primary_contact: string;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof OrganizationSalesCreate
     */
    roles_with_features_custom?: { [key: string]: Array<string>; } | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationSalesCreate
     */
    features?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSalesCreate
     */
    is_safeguard_organization: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSalesCreate
     */
    subscription_start_timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSalesCreate
     */
    trial_end_timestamp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSalesCreate
     */
    subscription_count: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSalesCreate
     */
    ops_subscription_count: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSalesCreate
     */
    respond_subscription_count: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSalesCreate
     */
    subscription_duration: number;
}

/**
 * Check if a given object implements the OrganizationSalesCreate interface.
 */
export function instanceOfOrganizationSalesCreate(value: object): value is OrganizationSalesCreate {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('company_name' in value) || value['company_name'] === undefined) return false;
    if (!('phone_number' in value) || value['phone_number'] === undefined) return false;
    if (!('primary_contact' in value) || value['primary_contact'] === undefined) return false;
    if (!('is_safeguard_organization' in value) || value['is_safeguard_organization'] === undefined) return false;
    if (!('subscription_start_timestamp' in value) || value['subscription_start_timestamp'] === undefined) return false;
    if (!('subscription_count' in value) || value['subscription_count'] === undefined) return false;
    if (!('ops_subscription_count' in value) || value['ops_subscription_count'] === undefined) return false;
    if (!('respond_subscription_count' in value) || value['respond_subscription_count'] === undefined) return false;
    if (!('subscription_duration' in value) || value['subscription_duration'] === undefined) return false;
    return true;
}

export function OrganizationSalesCreateFromJSON(json: any): OrganizationSalesCreate {
    return OrganizationSalesCreateFromJSONTyped(json, false);
}

export function OrganizationSalesCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationSalesCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'address': json['address'],
        'company_name': json['company_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone_number': json['phone_number'],
        'primary_contact': json['primary_contact'],
        'roles_with_features_custom': json['roles_with_features_custom'] == null ? undefined : json['roles_with_features_custom'],
        'features': json['features'] == null ? undefined : json['features'],
        'is_safeguard_organization': json['is_safeguard_organization'],
        'subscription_start_timestamp': json['subscription_start_timestamp'],
        'trial_end_timestamp': json['trial_end_timestamp'] == null ? undefined : json['trial_end_timestamp'],
        'subscription_count': json['subscription_count'],
        'ops_subscription_count': json['ops_subscription_count'],
        'respond_subscription_count': json['respond_subscription_count'],
        'subscription_duration': json['subscription_duration'],
    };
}

export function OrganizationSalesCreateToJSON(json: any): OrganizationSalesCreate {
    return OrganizationSalesCreateToJSONTyped(json, false);
}

export function OrganizationSalesCreateToJSONTyped(value?: OrganizationSalesCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'address': value['address'],
        'company_name': value['company_name'],
        'email': value['email'],
        'phone_number': value['phone_number'],
        'primary_contact': value['primary_contact'],
        'roles_with_features_custom': value['roles_with_features_custom'],
        'features': value['features'],
        'is_safeguard_organization': value['is_safeguard_organization'],
        'subscription_start_timestamp': value['subscription_start_timestamp'],
        'trial_end_timestamp': value['trial_end_timestamp'],
        'subscription_count': value['subscription_count'],
        'ops_subscription_count': value['ops_subscription_count'],
        'respond_subscription_count': value['respond_subscription_count'],
        'subscription_duration': value['subscription_duration'],
    };
}

